import { useMutation } from "@apollo/client";
import { DELETE_SFDC_INTEGRATION_MUTATION } from "../../../apis/salesforce/queries";
import { HG_FORCE_CLIENT } from "../../../utils/consts";

export interface DeleteIntegrationVariables {
  id: string;
}

export interface DeleteIntegrationResponse {
  deleteIntegration: boolean;
}

export interface UseDeleteIntegrationOptions {
  onCompleted?: (data: DeleteIntegrationResponse) => void;
  onError?: (error: Error) => void;
}

export const useDeleteIntegration = (
  options: UseDeleteIntegrationOptions = {}
) => {
  const { onCompleted, onError } = options;

  const [deleteIntegrationMutation, result] = useMutation<
    DeleteIntegrationResponse,
    DeleteIntegrationVariables
  >(DELETE_SFDC_INTEGRATION_MUTATION, {
    context: { clientName: HG_FORCE_CLIENT },
    onCompleted,
    onError,
    errorPolicy: "all",
  });

  const deleteIntegration = async (variables: DeleteIntegrationVariables) => {
    try {
      const response = await deleteIntegrationMutation({ variables });
      return response.data?.deleteIntegration;
    } catch (error) {
      console.error("Error deleting integration:", error);
      throw error;
    }
  };

  return {
    deleteIntegration,
    loading: result.loading,
    error: result.error,
    data: result.data,
  };
};
